import { ResourceType } from '@/core/components/ResourceLink';
import { DataType } from '@/core/interfaces/common';
import { routePaths } from '@/core/constants/routes';

import { ArticleLink } from '@/features/Articles/Articles.types';

import {
  ArticleResult,
  MediaResult,
  MomentLink,
  MomentResult,
  SearchItem,
} from './Search.types';

export const formatSearchResultItem = (item: SearchItem) => {
  const { image } = item;
  let formattedImage;

  if (image) {
    const {
      id,
      ...attrubutes
    } = image;

    formattedImage = {
      data: {
        attributes: {
          ...attrubutes,
        },
        id,
      },
    };
  } else {
    formattedImage = null;
  }

  switch (item.searchType) {
    case ResourceType.MEDIA: {
      const {
        id,
        title,
        subtitle,
        createdAt,
        link,
      } = item as MediaResult;

      return {
        attributes: {
          date: createdAt,
          image: formattedImage,
          link,
          subtitle,
          title,
        },
        id,
      };
    }
    case ResourceType.MOMENT: {
      const {
        id,
        title,
        popupTitle,
        createdAt,
      } = item as MomentResult;

      return {
        attributes: {
          date: createdAt,
          image: formattedImage,
          subtitle: popupTitle,
          title,
        },
        id,
      } as DataType<MomentLink>;
    }
    case ResourceType.ARTICLE:
    default: {
      const {
        id,
        title,
        subtitle,
        createdAt,
        slug,
      } = item as ArticleResult;

      return {
        attributes: {
          date: createdAt,
          image: formattedImage,
          link: `${routePaths.vision}/${slug}`,
          readingTime: null,
          subtitle,
          title,
        },
        id,
      } as DataType<ArticleLink>;
    }
  }
};
